import { getUser, getAlumniId, getToken, getKey, removeSession, refreshPage } from "Helpers/Utils/Common";
import { postAPICall, postAPICallCustom } from "../axiosMethodCalls";

/***************************
 * USER
 ***************************/

const token = getToken();
const user = getUser();

//POST
export const createMembership = async (data) => {
    try {
        const response = await postAPICall(process.env.REACT_APP_LINK + "alumni_organizations/add", {
            requester: user,
            // token: token,
            token: token,  
            alumni_id: user,
            name: data.name,
            type: data.type,
            is_international:data.international_company === "on" ? 1:0,
            membership_period: data.membership_period,
            position: data.position,
        });
        return ({data:response});   
    } catch (error) {
        if (error.response.status === 401) {
          removeSession();
          refreshPage();
        }
        return ({error: error.response});
    }
  }

export const getMembership= async (id,alumni_id) => {
  try {
      const response = await postAPICall(process.env.REACT_APP_LINK + "alumni_organizations/get", {
          requester: user,
          token: token,
          alumni_org_id: id,
          alumni_id:alumni_id
      });
      return ({data:response.data.data});   
  } catch (error) {
      if (error.response.status === 401) {
        removeSession();
        refreshPage();
      }
      return ({error: error.response});
  }
}

export const updateMembership = async (id, data) => {
  try {
      const response = await postAPICall(process.env.REACT_APP_LINK + "alumni_organizations/update", {
          requester: user,
          token: token,
          alumni_org_id: id,
          name: data.name,
          type: data.type,
          is_international:data.is_international === "on" ? 1:0,
          membership_period: data.membership_period,
          position: data.position,
      });
      return ({data:response});   
  } catch (error) {
      if (error.response.status === 401) {
        // toast.error(
        //   "Unauthorized access: another device is using this account"
        // );
        removeSession();
        refreshPage();
      }
      return ({error: error.response});
  }
}

export const deleteMembership = async (id) => {
  try {
      const response = await postAPICall(process.env.REACT_APP_LINK + "alumni_organizations/delete", {
          requester: user,
          token: token,
          alumni_org_id: id,
          // package_type_id: id,
      });
      return ({data:response});   
  } catch (error) {
      if (error.response.status === 401) {
        // toast.error(
        //   "Unauthorized access: another device is using this account"
        // );
        removeSession();
        refreshPage();
      }
      return ({error: error.response});
  }
}

//POST
export const editUser = async (info, branches, file) => {
  var branchesData = [];

  branches.map((data) => (
    branchesData.push(data.value)
  ));
  try {
    const formData = new FormData();
    //Change param name according to the asked param from API
    formData.append("file_result", file[0]);
    const response = await postAPICallCustom(
      process.env.REACT_APP_LINK + "/login",
      {
        // requester: user,
        token: token,
        username: info.username,
        password: info.password,
        last_name: info.last_name,
        first_name: info.first_name,
        middle_name: info.middle_name,
        email: info.email_address,
        type: info.user_type,
        role_id: info.role,
        branch_ids: branchesData.join(","),
      },
      {
        "api-key": "daccfc89-ff47-4ce1-99bf-5ad2d8f57282",
        // "user-key": userKey,
        "Content-Type": "multipart/form-data",
      },
    );

    return { data: response };
  } catch (error) {
    return { data: error.response.data };
  }
};